import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useCommonStore from 'store/useCommonStore';

/** 검색 페이지 진입 시 쿼리 스트링에 값이 있을 경우 검색결과를 가져옴
 * @수정사항 굳이 refetch를 해주지 않아도, 키워드가 변경 될 경우 새로운 검색결과를 가져오므로, refetch 기능은 제거. (전역상태에 저장.)
 * @return query_condition: 쿼리 스트링이 유효한 경우의 조건
 */
const useSearchRefetch = () => {
	// query params
	const [search_params] = useSearchParams();
	const keyword_query = search_params.get('keyword');

	// store
	const { keyword, setKeyword } = useCommonStore();

	useEffect(() => {
		if (!keyword_query) return;

		if (keyword.trim() === '') setKeyword(keyword_query);
	}, [keyword_query]);
};

export default useSearchRefetch;
